import { useState } from "react";
import styles from "./ReportsIncome.module.css";
import CustomSelect from "../../customComponents/CustomSelect";

const ReportsIncome = () => {
  const [filters, setFilters] = useState({
    organization: "",
    branch: "",
    cashier: "",
    paymentType: "",
    period: "",
  });

  const handleChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = () => {
    console.log("Показать отчёт с фильтрами:", filters);
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Доход и расход</h2>
      <p className={styles.subtitle}>
        Здесь отображаются все данные по доходам и расходам за выбранный период.
      </p>

      <div className={styles.box}>
        <CustomSelect
          placeholder="Выберите Склад"
          value={filters.organization}
          onChange={(val) => handleChange("organization", val)}
        />
        <CustomSelect
          placeholder="Выберите Сотрудника"
          value={filters.branch}
          onChange={(val) => handleChange("branch", val)}
        />
        <CustomSelect
          placeholder="Год"
          value={filters.cashier}
          onChange={(val) => handleChange("cashier", val)}
        />
        <CustomSelect
          placeholder="Месяц"
          value={filters.paymentType}
          onChange={(val) => handleChange("paymentType", val)}
        />
        <CustomSelect
          placeholder="День"
          value={filters.period}
          onChange={(val) => handleChange("period", val)}
        />

        <button className={styles.button} onClick={handleSubmit}>
          Показать отчёт
        </button>
      </div>
    </div>
  );
};

export default ReportsIncome;
